const schema = {};
schema.Article = require("./Article.js");
/**
 * Schema.org/Report
 * A Report generated by governmental or non-governmental organization.
 *
 * @author schema.org
 * @class Report
 * @module org.schema
 * @extends Article
 */
module.exports = class Report extends schema.Article {
	/**
	 * Constructor, automatically sets @context and @type.
	 *
	 * @constructor
	 */
	constructor() {
		super();
		this.setContextAndType("http://schema.org/","Report");
	}

	/**
	 * Schema.org/reportNumber
	 * The number or other unique designator assigned to a Report by the publishing organization.
	 *
	 * @property reportNumber
	 * @type Text
	 */
	reportNumber;

}